<script lang="ts" setup>
    const img = useImage();
    const config = useGlobyConfig();
</script>

<template>
    <header>
        <VCarousel :show-arrows="false" cycle height="200px" hide-delimiters>
            <VCarouselItem
                v-for="imgLoc of config.general.bannerImgs"
                :key="imgLoc"
                :src="img('/header/' + imgLoc, { format: 'webp' })"
                cover
            />
        </VCarousel>
    </header>
</template>

<style scoped></style>
